// extracted by mini-css-extract-plugin
export default {"center":"AutoCenter_center__ezHUj","centerContent":"AutoCenter_centerContent__XoOsA"};